export const STATUS_ERROR = 'Error';
export const STATUS_SEND = 'Send';
export const STATUS_NO = 'No';
export const STATUS_YES = 'Yes';
